export const search = {
   uri: "/data/work/search_museum.php",
} as const;
